module.exports = __webpack_public_path__ + "img/logo__country_oak_estates--light.f580e688.png";